<template>
  <div class="lezhi_project5_wrap">
    <headerBlack-view></headerBlack-view>
    <div class="introduce_wrap">
      <div class="introduce flex-layout">
        <div class="introduce_left">
          <div class="introduce_title flex-layout">
            <img src="@/assets/yunqiao/menu.png" />
            <div class="flex-column">
              <span>项目介绍</span>
              <img src="@/assets/yunqiao/introduce.png" />
            </div>
          </div>
          <div class="introduce_name">中小学综合素质</div>
          <div class="introduce_detail">
            素质教育是以提高受教育者多方面素质为目标的教育模式，重视人的思想道德、
            能力培养、个性发展、身体健康和心理健康，中小学阶段是学生相关能力培养的黄金阶段，
            基于项目学习过程中采集数据，依据数据证据链不断优化调整教育方式、教育体系，
            培养更多适应新时代中国需要的人才。为国家培养更多具有创造力、创新型人才。
            同时输出可视化报表便于对教育教学的研究工作。
          </div>
        </div>
        <div class="introduce_right flex-layout">
          <div class="introduce_item flex-column-center">
            <img src="@/assets/yunqiao/Evaluation.png" />
            <span>多维度评价体系</span>
            <span>Evaluation System</span>
          </div>
          <div class="introduce_item flex-column-center">
            <img src="@/assets/yunqiao/Clustering2.png" />
            <span>数据集群</span>
            <span>Data Clustering</span>
          </div>
          <div class="introduce_item flex-column-center">
            <img src="@/assets/yunqiao/Visual.png" />
            <span>可视化报表</span>
            <span>Visual Report</span>
          </div>
        </div>
      </div>
    </div>
    <div class="feature_wrap">
      <div class="feature_top flex-layout">
        <img src="@/assets/yunqiao/menu2.png" />
        <div class="flex-column">
          <span>产品特点</span>
          <img src="@/assets/yunqiao/features.png" />
        </div>
      </div>
      <div class="feature_bottom flex-between">
        <div class="feature_item flex-column">
          <div class="item_icon flex-align-around">
            <img src="@/assets/yunqiao/book.png" />
          </div>
          <div class="item_title">数据精准真实</div>
          <div class="item_content">数据基于学生真实学习情景采集，具有针对性和代表性。</div>
        </div>
        <div class="feature_item flex-column">
          <div class="item_icon flex-align-around">
            <img src="@/assets/yunqiao/note.png" />
          </div>
          <div class="item_title">评价体系覆盖全面</div>
          <div class="item_content">评价体系不覆盖学生学习多方因素，更为客观准确，规范综合评价工作。</div>
        </div>
        <div class="feature_item flex-column">
          <div class="item_icon flex-align-around">
            <img src="@/assets/yunqiao/visual2.png" />
          </div>
          <div class="item_title">数据可视化</div>
          <div class="item_content">通过使用多方位数据采集分析整理，多样报表，为分析者提供可视话通用报表。</div>
        </div>
      </div>
    </div>
    <div class="architecture_wrap">
      <div class="architecture">
        <div class="architecture_top flex-layout">
          <img src="@/assets/yunqiao/menu.png" />
          <div class="flex-column">
            <span>架构形式</span>
            <img src="@/assets/yunqiao/architecture.png" />
          </div>
        </div>
        <div class="architecture_bottom flex-column">
          <div class="architecture_item flex-layout">
            <div class="item_num">01</div>
            <div class="item_content flex-layout">
                <div>核心</div>
                <div>为指导者提供相应的教育、教建议学为核心，借助互联网技术，搜集、分析整理可视化数据结果。</div>
            </div>
          </div>
          <div class="architecture_item2 flex-layout">
            <div class="item_num">02</div>
            <div class="item_content flex-align">
              <div>数据采集</div>
                <div>基于项目本地落地，结合项目地实际场景使用采集过程数据，对过程进行精细化采集，形成数据集群。</div>
            </div>
          </div>
          <div class="architecture_item flex-layout">
            <div class="item_num">03</div>
            <div class="item_content flex-align">
              <div>数据挖掘</div>
                <div>对数据集群数据进行挖掘、分析、整理，对教学行为、学习情景数据进行深度分析输出数据源。</div>
            </div>
          </div>
          <div class="architecture_item2 flex-layout">
            <div class="item_num">04</div>
            <div class="item_content flex-align">
              <div>可视化输出</div>
                <div>依托数据集群与数据的深度挖掘的结果进行分析结果输出展示报表，为学校、教师教育教学提供数据依托。</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="win_wrap">
      <div class="win_top flex-layout">
        <img src="@/assets/yunqiao/menu.png" />
        <div class="flex-column">
          <span>合作共赢</span>
          <img src="@/assets/yunqiao/win2.png" />
        </div>
      </div>
      <div class="win_bottom flex-layout">
        <div class="win_item flex-column-center">
          <img src="@/assets/yunqiao/win_item15.png" />
          <span>数据采集</span>
        </div>
        <div class="win_item flex-column-center">
          <img src="@/assets/yunqiao/win_item16.png" />
          <span>数据挖掘</span>
        </div>
        <div class="win_item flex-column-center">
          <img src="@/assets/yunqiao/win_item17.png" />
          <span>可视化分析</span>
        </div>
        <div class="win_item flex-column-center">
          <img src="@/assets/yunqiao/win_item18.png" />
          <span>教育教研</span>
        </div>
        <div class="win_item flex-column-center">
          <img src="@/assets/yunqiao/win_item19.png" />
          <span>学生提高</span>
        </div>
      </div>
    </div>
    <footer-view></footer-view>
  </div>
</template>

<script>

export default {
  data(){
    return{
   
    }
  },
  methods:{

  },
  mounted(){

  }
};
</script>

<style lang="less" scoped>
@import "./less/lezhi_project5.less";
</style>